'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_io_OutputStream() {
}
export { $c_Ljava_io_OutputStream as $c_Ljava_io_OutputStream };
$p = $c_Ljava_io_OutputStream.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
}
export { $h_Ljava_io_OutputStream as $h_Ljava_io_OutputStream };
$h_Ljava_io_OutputStream.prototype = $p;
